export default function RealtimeCards() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">📈 Visualização em Cards</h2>
      <p>Em breve: painel de sinais com cards e gráficos.</p>
    </div>
  );
}